export default __webpack_public_path__ + "static/media/093-diagonal-arrow-11.2d20a334.png";